module.exports = __webpack_public_path__ + "img/FGr_Ortung_C.7c995cc3.svg";